import type { BranchBarcodeInputMode } from './store/useSessionStore';

export type ResolveBarcodeInputFlagsOptions = {
  /**
   * Web con shell de sidebar (PC). En modo `both` se oculta la cámara:
   * en mostrador el camino útil es pistola HID + campo de búsqueda.
   * Modo `camera` puro sigue mostrando el botón.
   */
  desktopShell?: boolean;
};

export function resolveBarcodeInputFlags(
  mode: BranchBarcodeInputMode | undefined,
  options?: ResolveBarcodeInputFlagsOptions,
) {
  const m = mode ?? 'both';
  const allowHardwareWedge = m === 'hardware' || m === 'both';
  const allowCameraByMode = m === 'camera' || m === 'both';
  const hideCameraOnDesktopBoth = options?.desktopShell === true && m === 'both';
  return {
    allowCamera: allowCameraByMode && !hideCameraOnDesktopBoth,
    allowHardwareWedge,
  };
}
